/* eslint-disable no-console */
/* global MobileApp:false */

import { isFunction } from 'lodash';
import { iOSWrapper } from '@/mixins/userAgent';
import log from '@/logger';

export default {
  userLoggedIn(token) {
    if (iOSWrapper) {
      window.location.href = `pred://userLoggedIn?token=${token}`;
    } else {
      if (typeof MobileApp === 'undefined') return;
      if (!isFunction(MobileApp.userLoggedIn)) return;
      try {
        MobileApp.userLoggedIn.bind(MobileApp)(token);
      } catch (err) {
        log.error(err);
      }
    }
  },
  userLoggedOut() {
    if (iOSWrapper) {
      window.location.href = 'pred://userLoggedOut';
    } else {
      if (typeof MobileApp === 'undefined') return;
      if (!isFunction(MobileApp.userLoggedOut)) return;
      try {
        MobileApp.userLoggedOut.bind(MobileApp)();
      } catch (err) {
        log.error(err);
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/services/mobile/wrapper.js